<template>
  <div class="columns is-multiline is-gapless">
    <div class="column is-6 is-border-bottom is-border-right is-border-dashed">
      <div class="column is-size-6 has-text-grey is-paddingless-bottom">Utilisateurs</div>
      <div v-if="usersCount && usersCount > 0" class="column">
        <router-link :to="{name: 'UserList'}">
          <span class="is-size-4">{{usersCount}} Utilisateur<span v-if="usersCount > 1">s</span></span>
        </router-link>
        <br>
        <router-link v-if="companies && companies > 0" :to="{name: 'CompanyList'}">
          <span class="is-size-7" v-if="companies">{{companies}} sociétés</span>
        </router-link>
      </div>
    </div>
    <div class="column is-6 is-border-bottom is-border-dashed">
      <div class="column is-size-6 has-text-grey is-paddingless-bottom">Stock disponible</div>
      <div class="column">
        <router-link v-if="programs" :to="{name: 'StockPrograms'}">
          <span class="is-size-4">{{programs}} programme<span v-if="programs > 1">s</span></span>
        </router-link>
        <br>
        <router-link v-if="lots" :to="{name: 'StockLots'}">
          <span class="is-size-7" v-if="lots">{{lots}} lot<span v-if="lots > 1">s</span></span>
        </router-link>
      </div>
    </div>
    <div class="column is-6 is-border-bottom is-border-right is-border-dashed">
      <div class="column is-size-6 has-text-grey is-paddingless-bottom">Option</div>
      <div class="column">
        <router-link :to="{name: 'OptionList'}">
          <span class="is-size-4">
            {{runningOptions.length}} option<span v-if="runningOptions.length >1">s</span> en cours
          </span>
        </router-link>
        <br>
        <router-link :to="{name: 'OptionList', query: {status: 'pending'}}">
          <span class="is-size-7">
            {{pendingOptions.length}} en attente<span v-if="pendingOptions.length > 1">s</span>
          </span>
        </router-link>
      </div>
    </div>
    <div class="column is-6 is-border-bottom is-border-dashed">
      <div class="column is-size-6 has-text-grey is-paddingless-bottom">Dénonciation</div>
      <div class="column">
        <router-link :to="{name: 'DenunciationList', query: {status: 'pending'}}">
        <span class="is-size-4">{{pendingDenunciations.length}} en attente<span
          v-if="pendingDenunciations.length > 1">s</span></span><br>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StatsMonitoring',
    props: {
      pendingDenunciations: Array,
      pendingOptions: Array,
      runningOptions: Array,
      programs: Number,
      companies: Number,
      usersCount: Number,
      lots: Number
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/home/dashboard-admin/stats-panel/StatsMonitoring.vue